import { cn } from '@/ui/cn';

/**
 * One placeholder block while data loads. Size and shape it with classes
 * (`h-4 w-1/2`, `aspect-square`, `rounded-full`); the sheen comes from the
 * `.skeleton` class in index.css.
 */
export function Skeleton({ className, style }) {
  return <span aria-hidden="true" className={cn('skeleton block', className)} style={style} />;
}

/**
 * Wraps a whole skeleton, so a screen reader hears "Loading products" once
 * instead of a run of empty shapes. `relative` keeps the visually hidden
 * label inside it - an absolute element escaping to a scroll container is
 * what once made phones zoom out.
 */
export function SkeletonRegion({ label, as: Tag = 'div', className, children }) {
  return (
    <Tag role="status" aria-busy="true" className={cn('relative', className)}>
      <span className="sr-only">Loading {label}</span>
      {children}
    </Tag>
  );
}
